import { getEnvironment, PRODUCTION, STAGING } from '@atlassian/temp-shared';
import { PARTNER_SUPPORT_STG_URL, PARTNER_SUPPORT_URL } from '@css-xp/ppc-constants';

export const getPartnerSupportUrl = () => {
  switch (getEnvironment()) {
    case STAGING:
      return PARTNER_SUPPORT_STG_URL;
    case PRODUCTION:
      return PARTNER_SUPPORT_URL;
    default:
      return PARTNER_SUPPORT_STG_URL;
  }
};

export const getPartnerServiceDeskUrlForGenericHelp = () => {
  return `${getPartnerSupportUrl()}#/?inquiry_category=partner_purchasing_center_support&reason=general_support`;
};

export const getPartnerServiceDeskUrlForTrialExtension = () => {
  return `${getPartnerSupportUrl()}#/?inquiry_category=partner_sales_support&partner_sales_support_topic=quotes_and_trials&reason=extended_evaluation_for_customer`;
};

export const getPartnerServiceDeskUrlForNewQuoteHelp = () => {
  return `${getPartnerSupportUrl()}#/?inquiry_category=partner_sales_support&partner_sales_support_topic=quotes_and_trials&reason=need_quote`;
};

export const getPartnerServiceDeskUrlForExistingQuoteHelp = () => {
  return `${getPartnerSupportUrl()}#/?inquiry_category=partner_sales_support&partner_sales_support_topic=quotes_and_trials&reason=help_with_existing_quote`;
};

export const getPartnerServiceDeskUrlForOnAccountApplication = () => {
  return `${getPartnerSupportUrl()}#/?inquiry_category=partner_sales_support&partner_sales_support_topic=apply_for_payment_terms&reason=apply_for_payment_terms`;
};
